var render = function render(){var _vm=this,_c=_vm._self._c;return _c('rkm-modal',{ref:"Modal",attrs:{"large":"","title":"Detalhes"},scopedSlots:_vm._u([{key:"footer",fn:function({cancel}){return [_c('rkm-button',{on:{"click":cancel}},[_vm._v(" Fechar ")])]}}])},[_c('rkm-table',{attrs:{"fields":_vm.fields,"items":_vm.items,"hide-filters":"","hide-pagination":"","thead-class":"d-none"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }